import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  summaryCard: {
    padding: theme.spacing(6),
    marginBottom: theme.spacing(4)
  },
  summaryStats: {
    marginTop: theme.spacing(2)
  },
  stat: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  causeHeader: {
    marginTop: theme.spacing(4)
  },
  causeList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(4),
    marginTop: theme.spacing(2)
  },
  causeItem: {
    marginRight: theme.spacing(4)
  },
  // Ignored entries stay visible but read as excluded.
  ignoredCard: {
    opacity: 0.5
  },
  itemHeader: {
    display: 'inline',
    marginRight: theme.spacing(2)
  },
  itemForm: {
    width: '100%'
  }
}));
